import React from 'react';

const Settings: React.FC = () => (
  <div className="space-y-6">
    <div>
      <p className="section-title">Administration</p>
      <h1 className="text-2xl font-semibold text-slate-900">Settings</h1>
      <p className="text-sm text-slate-500">
        Manage clinic preferences, notifications, and integrations.
      </p>
    </div>

    <div className="glass-panel space-y-6 p-6">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">Notification routing</h2>
        <p className="text-sm text-slate-500">
          Decide which teams receive critical updates.
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {['Surgery', 'ICU', 'Front desk', 'Pharmacy'].map((team) => (
          <label
            key={team}
            className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-3 text-sm font-medium text-slate-700"
          >
            <input type="checkbox" className="rounded border-slate-300 text-brand-blue focus:ring-brand-blue" />
            Send alerts to {team}
          </label>
        ))}
      </div>
    </div>

    <div className="glass-panel space-y-6 p-6">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">Integrations</h2>
        <p className="text-sm text-slate-500">
          Connect third-party services your team relies on.
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {['n8n Workflow', 'Slack', 'Zendesk'].map((integration) => (
          <div
            key={integration}
            className="rounded-2xl border border-slate-200 bg-white p-4 text-sm text-slate-600"
          >
            <p className="font-semibold text-slate-900">{integration}</p>
            <p className="text-xs text-slate-500">Status: Connected</p>
            <button className="mt-3 text-xs font-semibold text-brand-blue hover:underline">
              Manage
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Settings;
